/**
 * Stadsmuseum JavaScript & CSS library.
 *
 * @author Wouter Schotman <wouter@ideemedia.nl>
 * @copyright IdeeMedia.nl
 */

import "../scss/style.scss";
import { sliders } from "./_sliders";
import { search } from "./_search";
import { smoothScroll } from "./_smoothscroll";
import { sticky } from "./_sticky";

sliders();
search();
smoothScroll();
sticky();
